/**
 * OTRIX Play — contenido de RECUPERACIÓN para los días de descanso.
 *
 * Vive en el front a propósito: el catálogo del backend es de ejercicios de fuerza (is_play) y no
 * tiene contenido de recuperación. Son pautas fijas y universales (respiración y movilidad), no
 * datos del usuario, así que no necesitan tabla. Los textos salen de i18n (`play.recovery.*`).
 *
 * `pattern` = pauta de respiración con tiempo controlado: la UI cicla las fases y las cronometra.
 * Sin `pattern` es una práctica libre con cuenta regresiva y una lista de pasos.
 */

export const BREATHING_PHASES = ['inhale', 'hold', 'exhale', 'holdOut'];

export const RECOVERY_BLOCKS = [
  {
    key: 'breathing478',
    icon: 'Air',
    minutes: 4,
    // 4-7-8: inhala 4s, sostén 7s, exhala 8s. Baja pulsaciones y ayuda a dormir.
    pattern: [
      { phase: 'inhale', seconds: 4 },
      { phase: 'hold', seconds: 7 },
      { phase: 'exhale', seconds: 8 }
    ]
  },
  {
    key: 'boxBreathing',
    icon: 'CropSquare',
    minutes: 5,
    // Respiración cuadrada 4-4-4-4: la que usan para regular estrés antes de rendir.
    pattern: [
      { phase: 'inhale', seconds: 4 },
      { phase: 'hold', seconds: 4 },
      { phase: 'exhale', seconds: 4 },
      { phase: 'holdOut', seconds: 4 }
    ]
  },
  {
    key: 'yoga',
    icon: 'SelfImprovement',
    minutes: 10,
    steps: ['catCow', 'childPose', 'downwardDog', 'pigeon', 'savasana']
  },
  {
    key: 'mobility',
    icon: 'AccessibilityNew',
    minutes: 8,
    steps: ['neck', 'shoulders', 'hips', 'ankles']
  }
];

/** Duración total de un bloque en segundos. */
export const blockSeconds = (block) => Math.max(60, (block?.minutes || 1) * 60);

/**
 * Fase de respiración activa dado el tiempo transcurrido: cicla el patrón indefinidamente.
 * Devuelve la fase y los segundos que le quedan (para el contador y la animación).
 */
export const phaseAt = (pattern, elapsedSeconds) => {
  if (!pattern || pattern.length === 0) return null;

  const cycle = pattern.reduce((acc, p) => acc + p.seconds, 0);
  let offset = elapsedSeconds % cycle;

  for (let i = 0; i < pattern.length; i += 1) {
    if (offset < pattern[i].seconds) {
      return { phase: pattern[i].phase, remaining: pattern[i].seconds - offset, total: pattern[i].seconds };
    }
    offset -= pattern[i].seconds;
  }

  return { phase: pattern[0].phase, remaining: pattern[0].seconds, total: pattern[0].seconds };
};
